import { Injectable, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { jwtDecode } from 'jwt-decode';
import { Subject } from 'rxjs';
import { SiaUsersApi } from '../apis/sia-users.api';
import { SiaSessionParam } from '../interfaces/sia-session-param';
import { SiaTokenUser } from '../interfaces/sia-token-user';
import { SiaUserPermissions } from '../interfaces/sia-user-permissions';
import { SiaTokenStoreService } from './token-store.service';
@Injectable({
  providedIn: 'root',
})
export class SiaUsersService {
  private api = inject(SiaUsersApi);
  private tokenStoreService = inject(SiaTokenStoreService);
  #sanitizer = inject(DomSanitizer);

  private _userChanged: Subject<SiaTokenUser> = new Subject<SiaTokenUser>();
  private _avatarChanged: Subject<boolean> = new Subject<boolean>();
  private _language?: string | null;

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {
    this._language = window.sessionStorage.getItem('user-language');

    setInterval(() => {
      const userId = this.getRealUserId();
      if (!userId) return;
      this.heartbeat();
    }, 60000); // ogni minuto
  }

  get userChanged$() {
    return this._userChanged.asObservable();
  }
  userChanged() {
    var user = this.getUserData();
    if (user) {
      this._userChanged.next(user);
    }
  }
  userHaveGroup(groupId: string | number): boolean {
    var user = this.getUserData();

    if (!user?.groups) {
      return false;
    }
    if (typeof groupId === 'number') {
      switch (groupId) {
        case 1:
          groupId = 'admin';
          break;
        case 2:
          groupId = 'agent';
          break;
        default:
          groupId = groupId.toString();
          break;
      }
    }

    return user.groups.indexOf(groupId) != -1;
  }

  async setLanguage(language: string | undefined) {
    if (language) {
      await this.api.updateLanguage(language);
    }
  }

  getLanguage() {
    return this._language ?? this.getUserData()?.languageId;
  }

  async getEnableLanguages() {
    return await this.api.getEnableLanguages();
  }

  delete(id: number): Promise<boolean> {
    return this.api.delete(id);
  }

  inviteUser(userId: string) {
    return this.api.inviteUser(userId);
  }

  geSiaUserPermissions(componentId: string): Promise<SiaUserPermissions> {
    return this.api.geSiaUserPermissions(componentId);
  }

  getUserData(): SiaTokenUser | null {
    var accessToken = this.tokenStoreService.getAccessToken();
    if (!accessToken) return null;
    var decoded: any = jwtDecode(accessToken);
    if (!decoded) {
      return null;
    }
    if (!decoded?.userData) {
      return null;
    }
    var res: SiaTokenUser = JSON.parse(decoded.userData);
    return res;
  }

  getUserDefaultsData(): SiaSessionParam[] | null {
    var accessToken = this.tokenStoreService.getAccessToken();
    if (!accessToken) return null;
    var decoded: any = jwtDecode(accessToken);
    if (!decoded) {
      return null;
    }
    if (!decoded?.userDefaults) {
      return null;
    }
    var res = JSON.parse(decoded.userDefaults);
    return res;
  }

  getUserAvatar(uid?: number): Promise<any> {
    if (!uid) return Promise.resolve(null);
    return this.api.getAvatar(uid).then((blob: any) => {
      if (!blob) return null;
      if (blob.size === 0) return null;
      let objectURL = URL.createObjectURL(blob);
      let c = this.#sanitizer.bypassSecurityTrustUrl(objectURL);
      return c;
    });
  }
  getRealUserId(): number | null {
    var accessToken = this.tokenStoreService.getAccessToken();
    if (!accessToken) return null;
    var decoded: any = jwtDecode(accessToken);
    if (!decoded) {
      return null;
    }
    var res: number | null = decoded.userId ? +decoded.userId : null;
    return res;
  }

  //notify that the avatar has changed
  notifyAvatarChanged() {
    this._avatarChanged.next(true);
  }

  //method for notify that the avatr changed
  get avatarChanged$() {
    return this._avatarChanged.asObservable();
  }
  getUsersInGroups(groups: number[]) {
    return this.api.getUsersInGroups(groups);
  }

  createGroup(groupId: string) {
    return this.api.createGroup(groupId);
  }

  heartbeat() {
    return this.api.heartbeat();
  }
}
